module.exports = "../images/fishing-on-lake-home-3.jpg?v=9f1e730";